const Sage = window.Sage;
const grecaptcha = window.grecaptcha;

import filter from '@js/components/filter';
import Form from '@js/components/form';

export default {
  init() {
    this.events();
    filter.init();
    this.displayFilename();
  },

  events() {
    // Show choice buttons
    $('.btn-add-question').on('click', (e) => {
      const btn = $(e.currentTarget);

      btn.addClass('hidden');

      if (btn.data('user')) {
        $('.faq-form').slideDown();
      } else {
        const container = btn.closest('.faq__buttons--auth');
        container.find('.faq__buttons--inner').removeClass('hidden');
      }
    });

    // Show auth buttons
    $('.faq__button--login').on('click', (e) => {
      const btn = $(e.currentTarget);
      const container = btn.closest('.faq__buttons--auth');
      const loginBtns = container.find('.faq__buttons--login');

      container.find('.faq__buttons--inner').addClass('hidden');
      loginBtns.removeClass('hidden');

      $('.faq-form').slideUp();
    });

    $('.faq-form__cancel').on('click', () => {
      $('.btn-add-question').removeClass('hidden');
      $('.faq-form').slideUp();
    });

    // Guest
    $('.faq__button--guest').on('click', () => {
      $('.faq-form').slideDown();
    });

    // Handle form submit
    $('#faq-form').on('submit', (e) => {
      e.preventDefault();

      const formEl = $(e.currentTarget);
      formEl.addClass('loading');

      if (Form.validate(formEl)) {
        this.recaptcha(formEl);
      } else {
        formEl.removeClass('loading');
      }
    });
  },

  recaptcha(formEl) {
    const _self = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute(Sage.recaptcha_site_key, { action: 'submit' })
        .then(function (token) {
          _self.handleFormSubmit(formEl, token);
        });
    });
  },

  handleFormSubmit(formEl, token) {
    const formData = new FormData(formEl[0]);
    formData.append('token', token);

    const hasUploads = $('.form-field__upload');

    if (hasUploads.length) {
      let fileData = $('.form-field__upload')[0].files;

      $.each(fileData, function (index, file) {
        formData.append('file-' + index, file);
      });

      formData.delete('file');
    }

    $.ajax({
      url: Sage.ajaxurl,
      data: formData,
      processData: false,
      contentType: false,
      method: 'POST',
    })
      .done((response) => {
        if (response.success) {
          window.location.href = formEl.attr('data-url');
        } else {
          if (response.data.errors && response.data.errors.length) {
            response.data.errors.forEach((error) => {
              formEl
                .find(`.form-field__input[name=${error}]`)
                .addClass('error');
            });
          }
        }

        if (response.data.message) {
          formEl.find('.form__message').text(response.data.message);
        }

        formEl.removeClass('loading');
      })
      .error(() => {
        formEl.removeClass('loading');
      });
  },

  /**
   * Gathers all the filenames for uploaded files
   */
  displayFilename() {
    const self = this;

    var uploadedFileNames = [];

    $(document).on('change', '.form-field__upload', function () {
      uploadedFileNames = [];
      var files = $(this)[0].files;

      if (files.length > 3) {
        alert('Jūs varat ielādēt maksimums 3 failus.');
        $(this).val('');
        self.updateFileList([]);
        return;
      }

      for (var i = 0; i < files.length; i++) {
        uploadedFileNames.push(files[i].name);
      }

      self.updateFileList(uploadedFileNames);
    });
  },

  /**
   * Updates the form filelist
   */
  updateFileList(uploadedFileNames) {
    const resultEl = $('.form-field__upload-results');
    resultEl.html('');
    resultEl.removeClass('hidden');

    if (uploadedFileNames.length > 0) {
      for (var i = 0; i < uploadedFileNames.length; i++) {
        var fileName = uploadedFileNames[i];
        var fileSpan = $('<p class="form-field__filename">').text(fileName);
        $(resultEl).append(fileSpan);
      }
    }
  },
};
